module.exports = __webpack_public_path__ + "static/media/Scene-4.20bc8a58.jpg";